import { useContext, useEffect, useRef } from 'react';
import { GiveawayResponse, Stage } from '@org-avp/avp-hck-dga-customerui-commons';
import { getShowroomScriptSrc, getStreamingStage, injectShowroom } from './helper/util';
import { GiveawayContext } from '../../state/state';
import type {
  DeckConnectedEventDetail,
  DeckDisconnectedEventDetail,
  DeckOnExceptionEventDetail,
  WebStreamingProps,
} from './WebStreaming.types';
import { Brand } from '@org-avp/models';
import { useConfigurationContext } from '@/contexts/ConfigurationContext';

const WebStreaming = ({
  connected,
  initialized,
  disconnected,
  exception,
  active,
}: WebStreamingProps) => {
  const ref = useRef<HTMLElement>();
  const { market, prString, brand, marketingCode } = useContext<GiveawayResponse>(GiveawayContext);

  const isCommercialVehicles = brand === Brand.VW_NUTZFAHRZEUGE || marketingCode.startsWith('N');

  const configId = isCommercialVehicles ? 'n-dga-default-my2025' : 'v-dga-default-my2025';

  const configuration = useConfigurationContext();
  const stage = configuration?.stage ?? Stage.DEV;
  const scriptSrc = getShowroomScriptSrc(stage);

  useEffect(() => {
    const scriptElem = injectShowroom({
      scriptSrc,
      onLoad: () => {
        ref.current?.addEventListener('disconnected', ((
          e: CustomEvent<DeckDisconnectedEventDetail>,
        ) => {
          disconnected?.call(null, e);
        }) as EventListener);

        ref.current?.addEventListener('initialized', ((e: CustomEvent) => {
          initialized?.call(null, e);
        }) as EventListener);

        ref.current?.addEventListener('connected', ((e: CustomEvent<DeckConnectedEventDetail>) => {
          connected?.call(null, e);
        }) as EventListener);

        ref.current?.addEventListener('exception', ((
          e: CustomEvent<DeckOnExceptionEventDetail>,
        ) => {
          exception?.call(null, e);
        }) as EventListener);
      },
    });

    return () => {
      scriptElem.remove();
    };
  }, [stage, disconnected, exception, initialized, connected]);

  return (
    <>
      <avp-3dws-deck
        ref={ref}
        part="showroom"
        role="presentation"
        active={active}
        brand={brand}
        market={market}
        config-id={configId}
        pr-string={prString}
        streaming-stage={getStreamingStage()}
      />
    </>
  );
};

export default WebStreaming;
